import { Component, Input } from '@angular/core';

export type LoaderStyle = 'spinner' | 'dots' | 'pulse' | 'bars' | 'bounce';
export type LoaderTheme = 'primary' | 'success' | 'info' | 'warning' | 'danger' | 'light' | 'dark';

@Component({
  selector: 'app-inline-spinner',
  templateUrl: './inline-spinner.component.html',
  styleUrls: ['./inline-spinner.component.scss']
})
export class InlineSpinnerComponent {
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() message: string = '';
  @Input() customClass: string = '';
  @Input() style: LoaderStyle = 'spinner';
  @Input() theme: LoaderTheme = 'primary';
  @Input() overlay: boolean = false;
  @Input() centered: boolean = true;
}
